'use client';

import { SkeletonBar, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';

import type { InventoryStatusTone } from '../lib/inventory-status';
import './inventory-status.scss';

export type InventoryStatusProps = Readonly<{
    isLoading: boolean;
    label: string;
    tone?: InventoryStatusTone;
}>;

export function InventoryStatus({ isLoading, label, tone }: InventoryStatusProps) {
    if (isLoading) {
        return <SkeletonBar className="delivery-details__status-skeleton" data-testid="inventory-status-loading" />;
    }

    if (!label) return null;

    return (
        <TextPassage
            size="lg"
            data-testid="inventory-status"
            className={cn({
                'sparky-u-color-utility-success': tone === 'success',
                'sparky-u-color-utility-error': tone === 'error',
            })}
        >
            {label}
        </TextPassage>
    );
}
